export default __webpack_public_path__ + "static/media/476.37c35529.jpg";